<!-- @format -->

<money-tag>
  <div class="container_breadcrumb">
    <ul class="breadcrumb">
      <li class="breadcrumb-item"><a href="./" class="help">よくある質問</a></li>
      <li class="breadcrumb-item"><h1>報酬関連</h1></li>
    </ul>
  </div><!--/.container_breadcrumb-->
  
  <div class="contents">
    
    <section class="contents_area">
      
      <div class="contents_block">
        <div class="container_heading">
          <h2 class="heading-02 heading_help">報酬関連</h2>
        </div>
        
        <h3 class="heading-03 margin-spacing-3_top">報酬振込依頼～受取まで</h3>
          
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">獲得した報酬の履歴はどこで確認できますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">「受注履歴・請求関連」の項目からご確認いただけます。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">報酬を受け取る方法</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">ご本人様名義のお振込先の銀行口座をご登録いただきます。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">報酬受取口座は、どこから登録できますか</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text"><a href="/info">こちら</a>から登録していただきます。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">報酬を受け取るためのスケジュールを教えてください</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">プロジェクトが納品のステータスとなった月の翌月20日にご登録の銀行口座に報酬の振り込み処理が行われます。<br>※詳しくは<a href="/menu/help/flow/money ">こちら</a>をご参照ください。<br><span class="note">※20日が土日祝日にあたる場合は、翌営業日のお振り込みとなります。</span><br><span><n class="note">※振込先はお支払い月の1日未明に登録されている銀行口座へ入金となります。</n></span></span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">振込手数料は発生しますか</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">毎月20日の報酬金のお支払いに発生する振込手数料は弊社負担となります。（報酬金から差し引くということはありません。）</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">報酬振込日のはずですが、まだ振り込まれていません。何時に振り込まれますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">ご登録の口座情報に不備があるなどの理由でお振り込みができなかった場合は、翌月の繰り越しとなります。<br>必ず入金ができる正しい口座情報を登録するようにご注意ください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">報酬振込日に報酬が受け取れませんでした。なぜですか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">お振込先の銀行口座の登録情報にお間違えがないか今一度ご確認ください。<br>不備が見当たらない場合は、お手数をおかけいたしますが、お問い合わせまでご連絡ください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">獲得した報酬を引き出さずに貯めておくことは出来ますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">できません。プロジェクトが納品のステータスとなった月の翌月20日にご登録の銀行口座に報酬の振り込み処理が行われます。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">獲得報酬の振込先に、家族や友人の名義の銀行口座を登録できますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">できません。報酬の振込先はご自身の銀行口座をご登録ください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">口座名義に屋号が入っていますが、報酬の振込先として使用することは可能ですか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">EDILENTは個人の編集者・ライター様を対象にしたサービスになります。従ってご登録されている個人様の名義の振込口座しか指定することができません。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">領収書・請求書を発行できますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">支払調書機能の追加を予定しております。今しばらくおまちください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        
        <h3 class="heading-03 margin-spacing-3_top">確定申告・源泉徴収</h3>
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">確定申告する必要がありますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">確定申告をする必要があるかないかなどの詳細条件に関しては<a href"https://www.nta.go.jp/taxes/shiraberu/taxanswer/shotoku/2020.htm" target="_blank">国税庁のWEBサイト</a>をご参照ください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">支払調書を発行してくれますか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">支払調書機能の追加を予定しております。今しばらくおまちください。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">源泉徴収って何ですか？</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text">源泉徴収とは、年間の所得にかかる税金（所得税）をクライアント様が受注者である編集者・ライター様に支払う金額から、予め差し引くことをいいます。<br>EDILENTではクライアント様が法人の場合は、プロジェクトの報酬金額を源泉を引く前の金額と、源泉を差し引いた実際の入金額を表示します。</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        <div class="qa-wrap">
          <ul class="qa_list">
            <li class="qa_list-item q"><span class="icon"></span><span class="text">源泉徴収額の計算を教えてください</span></li>
            <li class="qa_list-item a"><span class="icon"></span><span class="text"><strong>【100万円以下の場合の計算方法】</strong><br>
              ■計算式■<br>
              源泉徴収税額 = 支払金額 × 10.21％<br><br>
              例）支払金額が50万円の場合<br>
              ・源泉徴収税額<br>50万円 × 10.21% = 51,050円<br><br>
              <strong>【100万円を超える場合の計算方法】</strong><br>
              ■計算式■<br>
              源泉徴収税額 =（支払金額 – 100万円）× 20.42％ ＋ 102,100円<br><br>
              例）支払金額が300万円の場合<br>
              ・源泉徴収税額<br>
              300万 – 100万円× 20.42% + 102,100円 = 510,500円</span></li>
          </ul>
        </div><!--	/.qa-wrap-->
        
        
      </div><!--/.contents_block-->
      
      
    </section><!--/.contents_area-->
    
  </div><!--/.contents-->
</money-tag>
